export default "__VITE_ASSET__BSQfFeFY__"